import { environment } from '../../../environments/environment';
import { INavbarTopLinkItem } from '../models/navbar-link-item.model';
import { integrationRoles, RolesEnum } from '../models/user-roles';

export const TopNavBarLinkItems: Record<string, INavbarTopLinkItem> = {
  Users: {
    name: 'Users',
    routerLink: '/dashboard/users/users-list',
    icon: 'icon-users-01',
    allowedRoles: [RolesEnum.ROLE_INTEGRATION_MANAGER],
  },
  Adapters: {
    name: 'Adapters',
    routerLink: '/dashboard/adapters/adapters-list',
    icon: 'icon-git-branch-01',
    allowedRoles: [RolesEnum.ROLE_INTEGRATION_MANAGER],
  },
  Endpoints: {
    name: 'Endpoints',
    routerLink: '/dashboard/endpoints',
    icon: 'icon-git-commit',
    allowedRoles: [RolesEnum.ROLE_INTEGRATION_MANAGER],
  },
  Mocks: {
    name: 'Mocks',
    routerLink: '/dashboard/mocks',
    icon: 'icon-beaker-01',
    allowedRoles: [RolesEnum.ROLE_INTEGRATION_MANAGER],
  },
  Requests: {
    name: 'Requests',
    routerLink: '/dashboard/requests/requests-list',
    icon: 'icon-git-pull-request',
    allowedRoles: [
      RolesEnum.ROLE_INTEGRATION_MANAGER,
      RolesEnum.ROLE_INTEGRATION_OPS,
    ],
  },
  Jobs: {
    name: 'Scheduled Endpoints',
    routerLink: '/dashboard/jobs',
    icon: 'icon-clock-stopwatch',
    allowedRoles: [
      RolesEnum.ROLE_INTEGRATION_MANAGER,
      RolesEnum.ROLE_INTEGRATION_OPS,
    ],
  },
  Reports: {
    name: 'Reports',
    routerLink: '/dashboard/reports/reports-list',
    icon: 'fa-regular fa-chart-bar',
    allowedRoles: environment.isMetabaseDashboardReportsEnabled
      ? integrationRoles
      : [],
  },
};
